import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { veNftMinimalAbi } from "@/domains/abis"
import { simulatedTransaction } from "../simulated-transaction"

type ApproveSuperVoterForAllProps = {
  account: Address
  chainId: number
  config: Config
  vestedAddress: Address
  superVoterAddress: Address
}

export const approveSuperVoterForAll = async ({
  account,
  chainId,
  config,
  vestedAddress,
  superVoterAddress,
}: ApproveSuperVoterForAllProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: veNftMinimalAbi as Abi,
        account,
        address: vestedAddress,
        args: [superVoterAddress, true],
        chainId,
        functionName: "setApprovalForAll",
      },
    })
    return result

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("approveSuperVoterForAll", error)
    return { success: false, error: error.message, code: error.code }
  }
}
